import { useSelector } from "react-redux";
import { selectData } from "../redux/features/userSliceWithTokenValidation";

function RenderByRole({ roles, children }) {
  const user = useSelector(selectData);
  return !user
    ? null
    : roles.includes(user?.statut) || roles.includes("*")
    ? children
    : null;
}

export default RenderByRole;
